module.exports = __webpack_public_path__ + "assets/terrorism.b85f072a.svg";